import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(private http: HttpClient) { }

  fetLactArticles(filters: any, includes?: string[]) {
    let url = `${environment.apiUrl}/api/list/article/conseil`;
    if (includes && includes.length > 0) {
      url += `?include=${includes.join(',')}`;
    }
    return this.http.post<any>(url, filters);
  }

  fetchDetailsArticle(id : any) {
    return this.http.get<any>(`${environment.apiUrl}/api/details/article/${id}/conseil`);
  }

  fetchCategories() {
    return this.http.get<any>(`${environment.apiUrl}/api/details/article/categorie`);
  }
  fetchLastOpinionSystem() {
    return this.http.get<any>(`${environment.apiUrl}/api/opinion-system/avis`);
  }

  downloadGuide(data: any) {
    return this.http.post<any>(`${environment.apiUrl}/api/guide/download`, data);
  }
}
